import { Component, OnDestroy, OnInit } from '@angular/core';

import { ControllerService } from '../shared/services/controller.service';

declare var $: any;

@Component({
    selector: 'app-quiz',
    templateUrl: './quiz.component.html',
    styleUrls: ['./quiz.component.scss'],
    standalone: false
})
export class QuizComponent implements OnInit, OnDestroy {

  selectedCorrectAnswer = false

  answers = []
  question = ''
  vertical = false

  pageObserver = null

  constructor(public controller: ControllerService) { }

  ngOnInit() {

    this.loadQuestion()

    this.pageObserver = this.controller.getPageObservers().subscribe( (p) => {

      this.loadQuestion()
    })

    this.vertical = this.controller.getSectionProperties().vertical == 'true'


  }

  ngOnDestroy(): void {
    this.pageObserver.unsubscribe()
  }

  loadQuestion( ){
    const page = this.controller.getStepItem().component

    if( !page || !page.elements ){
      return
    }

    this.selectedCorrectAnswer = false

    this.answers = page.elements.filter( ({type}) => type == 'answer-item').map( (it) => {

      return {
        label: it.value,
        valid: it.properties && it.properties.correct == 'true',
        selected: false
      }
    })

    this.question = page.elements.find( ({type}) => type == 'question').value


  }

  onAnswer(answer){
    if( this.selectedCorrectAnswer ){
      return
    }

    if( answer.valid == true ){
      this.selectedCorrectAnswer = true
    }else{
      this.selectedCorrectAnswer = false
    }

    this.answers.find( ({label}) => label == answer.label).selected = true
    this.answers.filter( ({label}) => label != answer.label).forEach( (it) => it.selected = false)

  }

  onNext() {

    this.controller.next()
  }


}
